import { render } from "./QuizFailedDetails.vue?vue&type=template&id=28d701a8&scoped=true&ts=true"
import script from "./QuizFailedDetails.vue?vue&type=script&lang=ts"
export * from "./QuizFailedDetails.vue?vue&type=script&lang=ts"

import "./QuizFailedDetails.vue?vue&type=style&index=0&id=28d701a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d701a8"]])

export default __exports__